import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDisclosure } from '@ds';
import { AdminFormRow, ConfirmationModal } from '@ui';
import { ControlledYesNoRadio } from '@lp/features/admin/forms/components/inputs/ControlledYesNoRadio';
import { NewHubForm } from '../types';

type SuperHubToggleProps = {
  isReadOnly?: boolean;
};

export const SuperHubToggle = memo(({ isReadOnly }: SuperHubToggleProps) => {
  const { control, setValue } = useFormContext<NewHubForm>();
  const isSuperHub = useWatch({ control, name: 'isSuperHub' });
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onChangeActive = async () => {
    setValue('isSuperHub', !isSuperHub, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <>
      <AdminFormRow title="Super Hub" isRequired>
        <ControlledYesNoRadio name="isSuperHub" isReadOnly={isReadOnly} onValueChange={onOpen} />
      </AdminFormRow>
      <ConfirmationModal
        title="Change Super Hub status?"
        description="Are you sure you want to change Super Hub status?"
        isOpen={isOpen}
        onChangeActive={onChangeActive}
        onClose={onClose}
      />
    </>
  );
});
